export const transactionType = {
  Provide: 'Provide',
  Replace: 'Replace',
  Change: 'Change',
  Disconnect: 'Disconnect',
  Accessory: 'Accessory',
  CancelDeal: 'CancelDeal'
};

const brandNameHe = () => window.Config?.brand_Name_HE;
export const actionDescription = {
  add: 'הוזמן',
  remove: 'הסרה',
  disconnect: 'הסרה',
  exists: 'קיים'
};

export const serviceDescription = {
  T: `שירות סלקום TV`,
  J: 'אינטרנט ביתי 100MB',
  M: 'טלפון ביתי'
};

export const notes = {
  Delivery: '* ישנה נוכחות חובה של אדם מעל גיל 18 בעת ביקור הטכנאי / שליח'
};

export const selfPickUpOrderStatus = {
  readyForDelivery: 'ready for delivery',
  create: 'created',
  salesForceEndActivity: 'sales_force_end_activity'
};

export const workOrderType = {
  CellcomTech: 'טכנאי תשתית',
  get Technician() {
    return `טכנאי ${brandNameHe()}`;
  },
  Delivery: 'שליחות',
  BezeqTechnician: 'טכנאי בזק',
  ExternalSupply: 'ספק חיצוני',
  SelfPickUp: 'איסוף עצמי'
};
export const generalSubscriber = '0000000000';
export const initialState = {
  isSuccess: false,
  errorCode: '1',
  callular: '',
  transactionData: {}
};
export const SapShopCode = {
  SelfPickUp: '0087'
};
export const ProductCode = {
  SBEQU: 'SBEQU'
};